import styled, { css } from "styled-components";

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ImageSpacer = styled.div<{ $width: number; $height: number }>`
  ${({ $width, $height }) => css`
    max-width: ${$width}px;

    &::before {
      content: "";
      padding-bottom: ${($height / $width) * 100}%;
      display: block;
    }
  `}
`;

export const ImageTag = styled.img<{ $objectFit: string }>`
  width: 100%;
  height: 100%;
  max-width: none;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  object-fit: ${({ $objectFit }) => $objectFit};

  ${ImageWrapper} & {
    position: absolute;
  }
`;
